import React from 'react';
import StateSection from "./state-section";
import { useLocation } from "react-router-dom";
import CitySection from "./city-section";
import JobsSection from "./jobs-section";
import ShipSection from "./ship-section";
import VisaSection from "./visa-section";
import WharfSection from "./wharf-section";
import RoleSection from "./role-section";
import UserSection from "./user-section";
import NewUser from "./new/new-user";
import AirPortSection from "./airport-section";
import AirlineSection from "./airline-section";
import EmailsSection from "./emails-section";
import CountrySection from "./countery-section";
import { JobLevels } from './JobLevels/JobLevels'
import { ShipTypes } from './ShipTypes/ShipTypes'
import { Documents } from './Documents/Documents'

const BasicInformationPage = () => {
  const pathname = useLocation().pathname

  return (
    <>
      {
        pathname?.includes("country") &&
        <CountrySection />
      }
      {
        pathname?.includes("state") &&
        <StateSection />
      }
      {
        pathname?.includes("city") &&
        <CitySection />
      }
      {
        pathname?.includes("jobs") &&
        <JobsSection />
      }
      {
        pathname?.includes("ship") && !pathname?.includes("type")&&
        <ShipSection />
      }
      {
        pathname?.includes("visa") &&
        <VisaSection />
      }
      {
        pathname?.includes("wharf") &&
        <WharfSection />
      }
      {
        pathname?.includes("airport") &&
        <AirPortSection />
      }
      {
        pathname?.includes("airline") &&
        <AirlineSection />
      }
      {
        pathname?.includes("role") &&
        <RoleSection />
      }
      {
        pathname?.includes("users") &&
        <UserSection />
      }
      {
        pathname?.includes("user/new") &&
        <NewUser />
      }
      {
        pathname?.includes("emails") &&
        <EmailsSection />
      }

      {pathname?.includes('job-levels') && <JobLevels />}

      {pathname?.includes('ship-type') && <ShipTypes />}

      {pathname?.includes('document') && <Documents />}


    </>
  );
};

export default BasicInformationPage;
